import type {
  UserPartnerCompanyProps,
  ProfileProps,
} from '@services/UserService';

export const getProfiles = (
  filteredPartnerCompaniesWithAccess: UserPartnerCompanyProps[],
  mergedRemovedPartnerCompanies: UserPartnerCompanyProps[],
  availableProfiles: ProfileProps[],
  selectedProfiles: ProfileProps[],
  selectedAllProfileId?: string,
  initialProfiles?: ProfileProps[],
) => {
  return availableProfiles
    ?.map(profile => {
      const isSelectedAllProfile = selectedAllProfileId === profile?.id;

      if (isSelectedAllProfile) {
        return {
          profileId: profile?.id,
          partnerCompaniesIncluded: [],
          partnerCompaniesExcluded: [],
          hasSelectedAllAvailablePartnerCompanies: true,
        };
      }

      const isProfileStillSelected = selectedProfiles?.some(
        item => item?.id === profile?.id,
      );

      const isProfileBeenSelected = initialProfiles?.some(
        item => item?.id === profile?.id,
      );

      if (!isProfileStillSelected && isProfileBeenSelected) {
        return {
          profileId: profile?.id,
          partnerCompaniesIncluded: [],
          partnerCompaniesExcluded: [],
          hasProfileBeenExcluded: true,
        };
      }

      const thisIncludedPartnerCompanies = filteredPartnerCompaniesWithAccess
        ?.filter(item => item?.profile?.id === profile?.id)
        ?.map(item => item?.partnerCompany);

      const thisExcludedPartnerCompanies = mergedRemovedPartnerCompanies
        ?.filter(item => item?.profile?.id === profile?.id)
        ?.map(item => item?.partnerCompany);

      return {
        profileId: profile?.id,
        partnerCompaniesIncluded: thisIncludedPartnerCompanies,
        partnerCompaniesExcluded: thisExcludedPartnerCompanies,
      };
    })
    ?.filter(
      item =>
        item?.partnerCompaniesIncluded?.length > 0 ||
        item?.partnerCompaniesExcluded?.length > 0 ||
        item?.hasSelectedAllAvailablePartnerCompanies ||
        item?.hasProfileBeenExcluded,
    );
};
